export default __webpack_public_path__ + "static/media/okr-outline-16px.ef7fe544.svg";